"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChannel = void 0;
var common_1 = require("@wix/wix-vod-constants/common");
var chance_1 = require("../chance");
var _deal_info_1 = require("./_deal-info");
var _stat_entity_1 = require("./_stat-entity");
var chance = (0, chance_1.getChance)();
var createChannel = function (videosCount) { return ({
    channelType: common_1.CHANNEL_TYPES.CHANNEL,
    coverUrl: chance.url({ extensions: ['jpg', 'gif'] }),
    createdTs: chance.date(),
    customCoverUrl: null,
    dealInfo: [(0, _deal_info_1.createDealInfo)()],
    description: chance.paragraph(),
    externalCreatedTs: null,
    featuredItem: null,
    id: chance.hash(),
    itemType: 'list',
    mediaType: common_1.MEDIA_TYPES.SECURE_VIDEO,
    onPublishedSite: true,
    ownerId: chance.hash(),
    state: null,
    statsInfo: {
        categories: [(0, _stat_entity_1.createStatEntity)()],
        tags: [(0, _stat_entity_1.createStatEntity)()],
    },
    subscriptionOnly: false,
    tags: [],
    title: chance.sentence({ words: 5 }),
    trailerInfo: null,
    updatedTs: chance.date(),
    urlType: '',
    videosCount: videosCount,
    itemId: chance.guid(),
}); };
exports.createChannel = createChannel;
//# sourceMappingURL=channel.js.map